export default __webpack_public_path__ + "static/model360-berlin-15cb2140e5d66b29418ea3eea4143bce.png";